/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteRequestBody = {
  /**
   * Override ID to delete
   */
  overrideId: string;
};

/** @internal */
export type DeleteRequestBody$Outbound = {
  override_id: string;
};

/** @internal */
export const DeleteRequestBody$outboundSchema: z.ZodMiniType<
  DeleteRequestBody$Outbound,
  DeleteRequestBody
> = z.pipe(
  z.object({
    overrideId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      overrideId: "override_id",
    });
  }),
);

export function deleteRequestBodyToJSON(
  deleteRequestBody: DeleteRequestBody,
): string {
  return JSON.stringify(
    DeleteRequestBody$outboundSchema.parse(deleteRequestBody),
  );
}
